// extracted by css-extract-rspack-plugin
export default {"select":"CalendarGroupModeSwitch_select__DxvhK"};